import { Action, actionCreatorFactory } from 'typescript-fsa'

import { Screen } from '../api/types'
import { FileType } from './types'

const actionCreator = actionCreatorFactory('Screen')

// fired from component/container to trigger loading a Screen
// should probably only be listened for by saga (to kick off the request)
export interface LoadScreenParams {
	id: number
	version: number
	language: string
	accountId?: number
}
export type LoadScreenAction = Action<LoadScreenParams>
export const loadScreen = actionCreator<LoadScreenParams>('LOAD_SCREEN')

export interface LoadedScreenResult {
	id: number
	version: number
	language: string
	screen: Screen
}
export type LoadedScreenResultAction = Action<LoadedScreenResult>
// Screen loaded from disk and needs to be stored on Redux store
export const loadedScreenFromDisk = actionCreator<LoadedScreenResult>('LOADED_SCREEN_FROM_DISK')

// delete an item from disk
// TODO this was just for testing caching
export const removeScreenFromDisk = actionCreator<LoadScreenParams>('REMOVE_SCREEN_FROM_DISK')

// load audio file path
export const loadAudioPath = actionCreator<FileRequestParams>('LOAD_AUDIO_PATH')
export const loadedAudioPath = actionCreator<FileRequestResult>('LOADED_AUDIO_PATH')
export const clearAudioPath = actionCreator<string>('CLEAR_AUDIO_PATH')

// load video file path
export const loadVideoPath = actionCreator<FileRequestParams>('LOAD_VIDEO_PATH')
export const loadedVideoPath = actionCreator<FileRequestResult>('LOADED_VIDEO_PATH')
export const clearVideoPath = actionCreator<string>('CLEAR_VIDEO_PATH')

export const loadFilePathError = actionCreator('LOAD_FILE_PATH_ERROR')

// download file
export type LoadedFilePathAction = Action<FileRequestParams>
export interface FileRequestParams {
	type: FileType
	fileName: string
	url: string
}

export interface FileRequestResult {
	fileName: string
	filePath: string
}

export const clearLoadScreenErrorAction = actionCreator<number>('CLEAR_LOAD_SCREEN_ERROR')
